import { render, staticRenderFns } from "./FormHabeasData.vue?vue&type=template&id=42761f67&scoped=true"
import script from "./FormHabeasData.vue?vue&type=script&lang=js"
export * from "./FormHabeasData.vue?vue&type=script&lang=js"
import style0 from "./FormHabeasData.vue?vue&type=style&index=0&id=42761f67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42761f67",
  null
  
)

export default component.exports